'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var utilities_combineClasses = require('./combineClasses-5P8GTQkg.js');
var theme_index = require('./index-CIVOGJRG.js');

require("../_assets/InternalFlexBox-DDJ1_Jgp.css");var styles = {"internalFlexBox":"InternalFlexBox__t1WHQjFdAU__internalFlexBox"};

const InternalFlexBox = react.forwardRef(({ as, style, className, children, testId, 
// CSSProps
display, width, minWidth, maxWidth, height, minHeight, maxHeight, flexDirection, flexWrap, justifyContent, alignItems, alignContent, flexGrow, flexShrink, flexBasis, gap, alignSelf, overflow, overflowX, overflowY, ...props }, ref) => {
    const As = as ?? 'div';
    const overFlowProps = overflow != null ? { overflow } : { overflowX, overflowY };
    return (jsxRuntime.jsx(As, { ref: ref, "data-testid": testId, className: utilities_combineClasses.combineClasses(styles.internalFlexBox, className), style: {
            display,
            width,
            minWidth,
            maxWidth,
            height,
            minHeight,
            maxHeight,
            flexDirection,
            flexWrap,
            justifyContent,
            alignItems,
            alignContent,
            flexGrow,
            flexShrink,
            flexBasis,
            gap: gap ? theme_index.theme.spacing[gap] : undefined,
            alignSelf,
            ...overFlowProps,
            ...style,
        }, ...props, children: children }));
});
InternalFlexBox.displayName = 'InternalFlexBox';

exports.InternalFlexBox = InternalFlexBox;
//# sourceMappingURL=InternalFlexBox-BDDWEQ9L.js.map
